module.exports = __webpack_public_path__ + "static/img/10.21b47ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/10.png
// module id = eGrO
// module chunks = 0